import type { IconProps } from "../types";

export const FileCode2 = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M4 12.15V2H14L20 8V22H14.65" />
    <path d="M14 2v6h6" />
    <path d="m5 16-3 3 3 3" />
    <path d="m9 22 3-3-3-3" />
  </svg>
);
